import Layout from '@/components/layout/index.vue'

export default {
  path: 'authorizationmanagement',
  name: 'Authorizationmanagement',
  meta: {},
  component: Layout,
  redirect: { name: 'Authorizationmanagement.Initialauthorization' },
  children: [
    {
      path: 'initialauthorization',
      name: 'Authorizationmanagement.Initialauthorization',
      meta: {},
      component: () => import('@/views/setting/authorizationmanagement/initialauthorization/index.vue')
    }
  ]
}
